import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LciAuthModule } from '@lciapps/auth';
import { TranslationModule } from '@lciapps/lci-core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CONFIG, translationConfig } from './app.config';
import { AppService } from './app.service';
import { CoreModule } from './core/core.module';
import { AnalyticsService } from './google-analytics/analytics.services';
import { DataLayerCustomDimensionsService } from './google-analytics/data-layer-custom-dimensions.service';
import { ProtectedComponent } from './protected/protected.component';
import { AuthCallbackComponent } from './root/auth-callback.component';
import { RootComponent } from './root/root.component';
import { SignoutComponent } from './root/signout.component';
import { SharedModule } from './shared/shared.module';
import { UtilityService } from './utility.service';


@NgModule({
  imports: [
    BrowserModule,
    TranslationModule.forRoot(translationConfig),
    LciAuthModule.forRoot(CONFIG),
    CoreModule.forRoot(),
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule
  ],
  declarations: [
    AppComponent,
    AuthCallbackComponent,
    ProtectedComponent,
    RootComponent,
    SignoutComponent
  ],
  providers: [
    AppService,
    AnalyticsService,
    UtilityService,
    DataLayerCustomDimensionsService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
